import React from "react";
import classnames from "classnames";
import style from "./Emote.module.scss";
import StrokedEmoteImage from "./StrokedEmoteImage";

interface EmoteProps {
  src: string;
  isSelected?: boolean;
  className?: string;
  isEnormous?: boolean;
  onClick?: () => void;
}

const Emote: React.FC<EmoteProps> = ({ src, isSelected, className, isEnormous, onClick }) => {
  return (
    <div
      className={classnames(style.emote, className, {
        [style.emote_enormous]: isEnormous,
      })}
      onClick={onClick}
    >
      <div
        className={classnames(style.emote__content, {
          [style.emote__content_selected]: isSelected,
        })}
      >
        <StrokedEmoteImage src={src} className={style.emote__img} />
      </div>
    </div>
  );
};

export default Emote;
